import { QueryTable } from "@/components/query-table/QueryTable";
import { DataTableQueryContextProvider } from "@/components/data-table/DataTableQueryContext";
import { CollapsibleSection } from "@/components/CollapsibleSection";
import { useTranslation } from "react-i18next";
import { useContractorAssignmentsList } from "../hooks/useContractorAssignmentsList";
import { ContractorPlannedHoursService } from "../contractorPlannedHoursService";
import { readContractorPlannedHours } from "@/schemas/contractorPlannedHours";
import { useState } from "react";
import { useContractorData } from "../hooks";
import { useFormatters } from "@/lib/hooks/useFormatters";
import { Section } from "@/components/details";
import { InsetWell } from "@/components/InsetWell";
import { readContractor } from "@/schemas/contractor";
import { Module } from "@/constants";

interface ContractorPlannedHoursListProps {
  contractorId: string;
}

export const ContractorPlannedHoursList = ({
  contractorId,
}: ContractorPlannedHoursListProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const contractor = useContractorData();
  const { formatDateTime, formatNumber } = useFormatters();

  const { query, filteredOptions } = useContractorAssignmentsList({
    name: "contractorPlannedHours",
    service: ContractorPlannedHoursService,
    contractorId,
    enabled: isOpen,
    sorting: [{ id: "period", desc: false }],
  });

  return (
    <CollapsibleSection
      title={t("contractors.plannedHours.title")}
      description={t("contractors.plannedHours.description")}
      defaultOpen={false}
      scrollIntoViewOnOpen
      onOpenChange={setIsOpen}
    >
      <InsetWell>
        <Section
          variant="card"
          module={Module.Contractors}
          schema={readContractor}
          data={contractor}
        >
          <Section.Field
            field="planned_hours_approved_at"
            value={formatDateTime(contractor.planned_hours_approved_at)}
          />
          <Section.Field
            field="planned_hours_approved_value"
            value={formatNumber(contractor.planned_hours_approved_value)}
          />
        </Section>
      </InsetWell>
      <QueryTable
        schema={readContractorPlannedHours}
        name="contractorPlannedHours"
        translationKey="contractorPlannedHours"
        query={query}
        options={filteredOptions}
      >
        <QueryTable.Menubar>
          <QueryTable.Menubar.Columns />
          <QueryTable.Menubar.Settings />
        </QueryTable.Menubar>
        <DataTableQueryContextProvider value={{ query }}>
          <QueryTable.Content isInDialog>
            <QueryTable.Status />
          </QueryTable.Content>
        </DataTableQueryContextProvider>
      </QueryTable>
    </CollapsibleSection>
  );
};
